// extracted by mini-css-extract-plugin
export default {"link":"backButton_link__N0III","button_text":"backButton_button_text__5pjqL","button_img":"backButton_button_img__X0tYi"};